import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitStatus("loading");
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d8se1d4jgj4v45gj7jrg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitStatus("success");
      setEmail("");
    } catch {
      setSubmitStatus("error");
    }
  };

  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="bg-secondary-100/50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight mb-3">
              Stay in the
              <br />
              Loop
            </h3>
            <p className="text-foreground-600 text-sm mb-6">
              Get the latest OOPBuy Spreadsheet guides, tips, and product updates delivered straight to your inbox.
            </p>
            <form
              onSubmit={handleSubscribe}
              data-readdy-form
              className="flex flex-col gap-3"
            >
              <label className="text-xs font-medium text-foreground-600">
                Email address
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="bg-transparent border-b border-foreground-300 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                disabled={submitStatus === "loading"}
                className="px-5 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-md hover:bg-foreground-50 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {submitStatus === "loading" ? "Joining..." : submitStatus === "success" ? "Subscribed!" : submitStatus === "error" ? "Try Again" : "Join"}
              </button>
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-6">
            <div className="flex flex-col gap-2.5">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-1">Categories</p>
              {col1.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-1">&nbsp;</p>
              {col2.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-1">&nbsp;</p>
              {col3.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-14 pt-6 border-t border-background-200/70 gap-3">
          <a href="/" className="font-heading text-lg font-bold text-foreground-900 cursor-pointer">
            OOPBuy <span className="italic font-normal text-primary-500">Spreadsheets</span>
          </a>
          <p className="text-xs text-foreground-500">
            &copy; 2026 OOPBuy Spreadsheets. This is an informational and affiliate guide platform.
          </p>
        </div>
      </div>
    </footer>
  );
}